<app-wizard-step-card [header]="'TELECOM.QUALIFICATION.TITLE' | translate" [formGroup]="form" (submit)="onSubmit()">
    <app-telecom-bundle-selection
        class="u-display-block u-w100p u-margin-bottom-double"
        [formControlName]="controlNames.Bundle"
        label="TELECOM.QUALIFICATION.BUNDLE.LABEL"
    ></app-telecom-bundle-selection>

    <app-select-input
        class="u-margin-bottom-triple"
        [options]="providerOptions"
        formControlName="provider"
        [hasMargin]="false"
        [hasMarginDouble]="false"
        [label]="'TELECOM.QUALIFICATION.PROVIDER.LABEL' | translate"
    ></app-select-input>

    <div class="u-position-relative" *ngIf="showBanner">
        <img
            [src]="telecomBannerUri"
            appTooltip
            [hidePointer]="true"
            [template]="tooltipContent"
            [placement]="placement.RightStart"
            class="u-margin-bottom-triple u-w100p"
            (error)="hideBanner()"
        />
    </div>

    <p class="u-color-muted u-margin-bottom-half">{{'TELECOM.QUALIFICATION.PROVIDER.INFO' | translate}}</p>
    <p class="u-margin-bottom">{{'TELECOM.QUALIFICATION.PROVIDER.TEXT' | translate}}</p>
</app-wizard-step-card>

<ng-template #tooltipContent>
    <p>{{telecomBannerTooltipResource | translate}}</p>
</ng-template>
